import { useSiteSettings } from "../../../contexts/SiteSettingsContext";
import ImageUploadField from "./ImageUploadField";

export default function AuthorTab() {
  const { settings, updateSettings } = useSiteSettings();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">著者プロフィール設定</h3>
        <div className="space-y-4">
          <ImageUploadField
            label="プロフィール画像（URLまたはアップロード）"
            value={settings.authorImageUrl}
            onChange={(url) => updateSettings({ authorImageUrl: url })}
            placeholder="https://example.com/avatar.jpg"
            previewShape="circle"
          />

          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">著者名</label>
            <input
              type="text"
              value={settings.authorName}
              onChange={(e) => updateSettings({ authorName: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="著者名"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">自己紹介（改行可）</label>
            <textarea
              value={settings.authorBio}
              onChange={(e) => updateSettings({ authorBio: e.target.value })}
              rows={4}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400 resize-y"
              placeholder="自己紹介文"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">著者のサイトURL</label>
            <input
              type="url"
              value={settings.authorSiteUrl}
              onChange={(e) => updateSettings({ authorSiteUrl: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="https://example.com"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">X(Twitter) URL</label>
            <input
              type="url"
              value={settings.authorTwitterUrl}
              onChange={(e) => updateSettings({ authorTwitterUrl: e.target.value })}
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
              placeholder="https://x.com/username"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
